






import Vue from 'vue'
interface IData {
  targetRectPosition: number
  impressionFlag: boolean
  routeName: string | undefined
}
export default Vue.extend({
  props: {
    pushEventName: {
      type: String,
      default: 'impression'
    }
  },
  data(): IData {
    return {
      targetRectPosition: 0,
      impressionFlag: false,
      routeName: this.$route.name
    }
  },
  mounted() {
    if (typeof window === 'object') {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed() {
    if (typeof window === 'object') {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll() {
      const target = this.$refs['target'] as Element
      const windowHeight = window.innerHeight
      const getRouteName = this.$route.name
      if (target) {
        this.targetRectPosition = target.getBoundingClientRect().top
        if (this.targetRectPosition - windowHeight < 0 && (!this.impressionFlag || this.routeName !== getRouteName)) {
          // 1回目はimpressionFlagで 2回目はrouteNameが違う場合に発火
          this.$gtm.push({
            event: 'impression_' + this.pushEventName,
            page_title: this.$route.meta.title
          })
          this.impressionFlag = true
          this.routeName = getRouteName
        }
      }
    }
  }
})
